import { useLocalStorage } from '../../utils/storageUtils';
import { ParamValues } from '../../shared/types/customReports';

const LOCAL_STORAGE_KEY = 'batch-report';

type ReportId = string;

type ReportParameters = {
  reportParamValues: ParamValues,
  isIncludedInExport: boolean,
}

export type LocalStorageBatchReportParameters = Record<ReportId, ReportParameters>

export const getKey = (batchReportId: number) => `${LOCAL_STORAGE_KEY}${batchReportId}`;

export const useBatchReportsFromLocalStorage = (batchReportId: number) =>
  useLocalStorage<LocalStorageBatchReportParameters>(getKey(batchReportId), {});
